const players = [
  { name: 'Fredrik Bylin', final_points: 114.24, mexicano_points: 102, boost: 12 },
  { name: 'Marcus Sjöberg', final_points: 103.5, mexicano_points: 90, boost: 15 },
  { name: 'Oscar Steen', final_points: 101, mexicano_points: 101, boost: 0 },
  { name: 'Joel Baudin', final_points: 99.36, mexicano_points: 92, boost: 8 },
  { name: 'Erik Nilsson', final_points: 97.76, mexicano_points: 94, boost: 4 },
  { name: 'Pär Edblom', final_points: 97.65, mexicano_points: 93, boost: 5 },
  { name: 'Håkan Martinell', final_points: 93.28, mexicano_points: 88, boost: 6 },
  { name: 'Victor Hansson', final_points: 90.2, mexicano_points: 82, boost: 10 },
  { name: 'Gabriel Baudin', final_points: 89, mexicano_points: 89, boost: 0 },
  { name: 'Mikael Nordstrand', final_points: 85.85, mexicano_points: 85, boost: 1 },
  { name: 'Johan Lindgren', final_points: 83, mexicano_points: 83, boost: 0 },
  { name: 'Viktor Andersson', final_points: 78, mexicano_points: 78, boost: 0 },
  { name: 'Andreas Cherif Fjällström', final_points: 77.25, mexicano_points: 75, boost: 3 },
  { name: 'Martin Carstedt', final_points: 76, mexicano_points: 76, boost: 0 },
  { name: 'Dennis Edlund', final_points: 76, mexicano_points: 76, boost: 0 },
  { name: 'Hanna Sjöberg', final_points: 72, mexicano_points: 72, boost: 0 },
  { name: 'Tommy Nilsson', final_points: 67, mexicano_points: 67, boost: 0 },
  { name: 'Åke Ödling', final_points: 58, mexicano_points: 58, boost: 0 },
  {
    name: 'Daniel Strand',
    final_points: 0,
    mexicano_points: 92,
    boost: 0,
    comment: 'Deltog inte i seriespelet.',
  },
  {
    name: 'Stefan Lyng',
    final_points: 0,
    mexicano_points: 87,
    boost: 0,
    comment: 'Deltog inte i seriespelet.',
  },
  {
    name: 'Fredrik Furevik',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Kasper Hellström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Mats Myrsell',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Lars Winqvist',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Mattias Modig',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Johan Edlund',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'David Rocksén',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Lucas Lundberg',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Thomas Pettersson',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Stefan Bergström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Niclas Sjöström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Tilde Nording',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Johnny Köster',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Anders Lönn',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Fredrik Sjöberg',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Karoline Bergström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Carl Söderström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Anders Jäger',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
  {
    name: 'Martin Söderström',
    final_points: 0,
    mexicano_points: 0,
    boost: 0,
    comment: 'Deltog inte i slutspelet.',
  },
]

export const FinalList = () => {
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Rank
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Namn
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Slutpoäng i ÖNP
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Totala poäng i Mexicano
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Boost
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Kommentar
                  </th>
                </tr>
              </thead>
              <tbody>
                {players.map((person, personIdx) => (
                  <tr key={person.name} className={personIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {personIdx + 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {person.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                      {person.final_points}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                      {person.mexicano_points}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                      {person.boost}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                      {person.comment}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
